<ng-container
    *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
    <div class="flex align-items-center">
        <div class="w-4rem">
            <p-tag *ngIf="$.row && $.adata.fetch_key && ($.row[$.adata.fetch_key] === true)" styleClass="text-xxs text-white uppercase font-normal" severity="warning">Void</p-tag>
            <p-tag *ngIf="$.row && $.adata.fetch_key && ($.row[$.adata.fetch_key] === false)" severity="success" styleClass="text-xxs font-normal uppercase white-space-nowrap">Completed</p-tag>
        </div>
    </div>
</ng-container>
